import React from 'react';
import { Box, Typography } from '@mui/material';
import { Seo } from 'src/components/seo';
import ThemedCard from 'src/e2e-redesign/components/ThemedCard';

interface AggregatorErrorProps {
  title?: string;
  message: string;
  errorCode?: number;
}

export default function AggregatorError({ title, message, errorCode }: AggregatorErrorProps) {
  const displayTitle = title || (errorCode === 401 ? 'Token Expired' : errorCode === 404 ? 'Not Found' : 'Error');

  return (
    <>
      <Seo title={`Error ${errorCode || ''}`} />
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh', padding: '20px' }}>
        <ThemedCard sx={{ maxWidth: '600px', width: '100%' }}>
          <Typography variant="h4" sx={{ marginBottom: '20px', color: '#243F8F', fontWeight: 700 }}>
            {displayTitle}
          </Typography>
          <Typography variant="body1" paragraph>
            {message}
          </Typography>
          {errorCode === 401 && (
            <Typography variant="body2" sx={{ marginTop: '20px', color: '#666' }}>
              Please contact support or refresh the page if you have a new token.
            </Typography>
          )}
        </ThemedCard>
      </Box>
    </>
  );
}
